<template>
  <div class="page-other">
    <div class="navigation-wrapper">
    <TopNavbar></TopNavbar>
      <navbar />
      <AlertBox></AlertBox>
      </div>
      <Header :background_image="backgroundImage">
          <template 
            v-slot:title>
              OSTALE JEDI
          </template>
          <template 
            v-slot:subtitle>
              vsak dan, za vse okuse
          </template>
      </Header>
      <DeliveryBanner></DeliveryBanner>

      <Intro>
        <template 
          v-slot:description>
          Če si zaželite <strong>hrustljavega & nasitnega solatnega krožnika</strong>, našega slavnega <strong>prebranca iz krušne peči</strong>, ocvrtih kalamarov ali pa preprostega klasičnega kosila z dunajskim zrezkom, potem ste na pravem naslovu! Za piko na i pa si privoščite <strong>Marlenko</strong> - medeni čudež po Armenskem družinskem receptu ali pa katero od naših vrhunskih domačih sladic. 
        </template>
        <template 
          v-slot:title-last>
            ...pa dober tek!
        </template>
        <template 
          v-slot:image-11>
            <img src="../assets/solata.jpg">
        </template>
        <template 
          v-slot:image-1>
            Sveže in nasitne solate
        </template>
        <template 
          v-slot:image-22>
            <img src="../assets/prebranac.jpg">
        </template>
        <template 
          v-slot:image-2>
           Okusna domača kosila
        </template>
        <template 
          v-slot:image-33>
            <img src="../assets/marlenka.jpg">
        </template>
        <template 
          v-slot:image-3>
            Pregrešno dobre sladice
        </template>
        
      </Intro>

      <Tabs :labels="this.labels" :isDelivery="this.isDelivery">
        <template 
          v-slot:mainTitle>
          Ostale jedi
        </template>
      </Tabs>

      <Guests :testimonials="testimonials" :gallery="gallery"></Guests>
      <Footer></Footer> 
      <cookieConsent></cookieConsent>
  </div>
</template>

<style lang="scss">

@import '../components/variables.scss';

.page-pizzas {
    .subpage-header {
        background-image: url('../assets/salad.jpg');
        margin-top:120px;
    }

    .pizzas-content {
        width:100%;
        max-width:1200px;
        margin:0 auto;
        padding: 1em;
        box-sizing: border-box;

        .pizzas-intro {
            margin:4em 0 0 0;
            line-height: 2;
            text-align: left;
            @include screen('mobile') {
              margin:2em auto;
            }
        }
    }
}
</style>

<script>
import backgroundImage from '@/assets/salad.jpg'
import TopNavbar from "@/components/TopNavbar/TopNavbar"
import Navbar from "@/components/MainNavbar/Navbar"
import Header from "@/components/Header/Header"
import DeliveryBanner from "@/components/DeliveryBanner/DeliveryBanner"
import Intro from "@/components/Intro/Intro"
import Footer from "@/components/Footer/Footer"
import Guests from "@/components/Guests/Guests"
import AlertBox from "@/components/AlertBox/AlertBox"
import Tabs from "@/components/Tabs"
import cookieConsent from "@/components/cookieConsent"
export default {
  name: "Home",
  data: () => ({
    isDelivery: false,
    backgroundImage,
    testimonials: [
        { name: 'Bojan G.', message: 'Vsec mi je njihov solatni kroznik in pica v krusni peci pecena je pa itak in...'},
        { name: 'Mladen L.', message: 'Ambient všečen, poleti je pod trto pravi užitek jesti. Glede postrežbe res ni pripomb...strežno  osebje prijazno, hitro, ustrežljivo...Pri velikosti porcij ni šparanja, pice gledajo čez rob krožnika. Testo je mehko, ni tanko, pica bogato obložena. Pomfri dober, debelo narezan, pohan sir in piščančji kroketki odlični...Okus hrane čista 5.'},
        { name: 'Rok S.', message: 'Pice so sicer odlične, ampak je postrežba in družba še boljša!'}
    ],
    labels: [
            {
                label: 'Solate',
                id: 4
            },
            {
                label: 'Ostale jedi',
                id: 9
            },
            {
                label: 'Sladice',
                id: 2
            }
        ]
  }),
  components: {
      TopNavbar,
      Navbar,
      AlertBox,
      Header,
      DeliveryBanner,
      Intro,
      Tabs,
      Guests,
      Footer,
      cookieConsent
  },
  computed: {
        meals() {
        return this.$store.getters.allMeals
        },

        other() {
        return this.meals.filter(meal => meal.types[0].id === 9)
        },

        salad() {
        return this.meals.filter(meal => meal.types[0].id === 4)
        },

        deserts() {
        return this.meals.filter(meal => meal.types[0].id === 2)
        },
        gallery() {
			return this.$store.getters.allGalleryPizzas
		},
	},
	mounted() {
        this.$store.dispatch("getMeals")
        this.$store.dispatch("getGalleryPizzas")
	},
};
</script>

<style lang="scss" scoped>

.subpage-header {
    font-size:1.2rem;
}

</style>